import React, { useEffect, useRef, useState } from 'react';
import styles from './Accordion.module.scss';
import Icon from '../Icon/Icon';
import cx from 'classnames';

export const AccordionItem = ({ item, className, defaultState = false, onTransitionEnd }) => {
  const [isActive, setIsActive] = useState(defaultState);

  const contentRef = useRef(null);

  useEffect(() => {
    let timeoutId = null;
      if (isActive) {
        contentRef.current.style.height = contentRef.current.scrollHeight + 'px';
        contentRef.current.style.transition = 'height 0.25s ease-in-out';
  
        timeoutId = setTimeout(() => {
          // Reset height to auto after transition to allow for dynamic content changes
          if (contentRef?.current?.style) {
            contentRef.current.style.height = 'auto';
          }
        }, 250); // Match the transition duration
      } else {
        if (contentRef.current.offsetHeight !== 0) {
          contentRef.current.style.height = contentRef.current.scrollHeight + 'px'; // Set to current height to animate collapse
          timeoutId = setTimeout(() => {
            contentRef.current.style.height = 0; // Collapse to 0 height
          }, 100);
        }
      }

      return () => {
        clearTimeout(timeoutId);
      };

  }, [isActive]);

  return (
    <div className={cx(styles.itemContainer, { [styles.noGap]: !isActive }, className)}>
      <div className={styles.itemTitle} onClick={() => setIsActive(prevState => !prevState)}>
        {item.title}
        <Icon className={cx(styles.arrowIcon, { [styles.rotate]: isActive })} src="arrowDown" />
      </div>
      <div ref={contentRef} className={styles.itemContent} onTransitionEnd={onTransitionEnd}>{item.content}</div>
    </div>
  );
};
